import { usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/inertia"

// Professional-body badges. The logo files are white/transparent variants, so
// this always renders on a dark ground — hence the teal panel when `panel` is
// set (About Me, on a light page) and the bare row inside the dark footer.
const ACCREDITATIONS = [
  { src: "/logos/babcp.png", alt: "BABCP Accredited", href: "https://www.babcp.com/", h: "h-20" },
  { src: "/logos/emdr-europe.png", alt: "EMDR Europe", href: "https://emdr-europe.org/", h: "h-20" },
  { src: "/logos/emdr-uk.png", alt: "EMDR Association UK", href: "https://emdrassociation.org.uk/", h: "h-16" },
  {
    src: "/logos/psa-accredited-register.png",
    alt: "Professional Standards Authority — Accredited Register",
    href: "https://www.professionalstandards.org.uk/accredited-registers",
    h: "h-16",
  },
  { src: "/logos/psychology-today.png", alt: "Verified by Psychology Today", href: null, h: "h-12" },
  {
    src: "/logos/ico.png",
    alt: "Registered with the Information Commissioner's Office (ICO)",
    href: "https://ico.org.uk/",
    h: "h-14",
  },
]

export function AccreditationBadges({ panel = false }: { panel?: boolean }) {
  const t = usePage<PageProps>().props.translations.gisela_nav

  const row = (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-4">
      {ACCREDITATIONS.map(({ src, alt, href, h }) => {
        const img = <img src={src} alt={alt} loading="lazy" className={`${h} w-auto`} />

        return href ? (
          <a key={src} href={href} target="_blank" rel="noopener noreferrer" title={alt}>
            {img}
          </a>
        ) : (
          <span key={src} title={alt}>
            {img}
          </span>
        )
      })}
    </div>
  )

  if (!panel) return row

  return (
    <div className="rounded-2xl bg-teal p-8">
      <h6 className="mb-5 text-white/50">{t.accreditations}</h6>
      {row}
    </div>
  )
}
